import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MemberService } from './../../../rest/api/member.service';
import { AuthService } from './../../../services/auth.service';
@Component({
  selector: 'app-delete-floorplan',
  templateUrl: './delete-floorplan.component.html',
  styleUrls: ['./delete-floorplan.component.scss']
})
export class DeleteFloorplanComponent implements OnInit {
  @Input() floorPlanData;
  @Input() spaceData;
  deleteFloorplanError;
  deleteFloorplanSuccess;
  @Output() deleteFloorPlanEmit = new EventEmitter();

  isSubmitted = false;
  accessToken: any;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }

  deleteFloorplan() {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteFloorplanEmit();
  }

  deleteFloorplanEmit() {
    this.deleteFloorplanError = undefined;
    this.memberService.deleteFloorplan({
      Authorization: this.accessToken,
      id: this.floorPlanData.uuid
    }).subscribe((response: any) => {
      this.deleteFloorplanSuccess = 'Floorplan was deleted successfully.';
      setTimeout(() => {
        this.deleteFloorPlanEmit.emit(true);
      }, 2000);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteFloorplanError = err.error.error;
      } else {
        this.deleteFloorplanError = 'There was error while deleting space.';
      }
    });
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteFloorplanSuccess = undefined;
    this.deleteFloorplanError = undefined;
  }

}
